import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * BookingExceptionsApi - axios parameter creator
 * @export
 */
const BookingExceptionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (bookingTypeId, options = {}) => {
            const localVarPath = `/v1/BookingExceptions/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByDateRange: async (bookingTypeId, startDate, endDate, options = {}) => {
            const localVarPath = `/v1/BookingExceptions/GetByDateRange`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (bookingTypeId !== undefined) {
                localVarQueryParameter['bookingTypeId'] = bookingTypeId;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                    startDate.toISOString() :
                    startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                    endDate.toISOString() :
                    endDate;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/BookingExceptions/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExceptionTypes: async (options = {}) => {
            const localVarPath = `/v1/BookingExceptions/GetExceptionTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeModes: async (options = {}) => {
            const localVarPath = `/v1/BookingExceptions/GetTimeModes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (BookingExceptionToken, cancelAffected, options = {}) => {
            const localVarPath = `/v1/BookingExceptions/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (cancelAffected !== undefined) {
                localVarQueryParameter['cancelAffected'] = cancelAffected;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingExceptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/BookingExceptions/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {number} [id]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (BookingExceptionToken, id, cancelAffected, options = {}) => {
            const localVarPath = `/v1/BookingExceptions/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            if (cancelAffected !== undefined) {
                localVarQueryParameter['cancelAffected'] = cancelAffected;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingExceptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExceptionConflicts: async (BookingExceptionToken, options = {}) => {
            const localVarPath = `/v1/BookingExceptions/ValidateExceptionConflicts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(BookingExceptionToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BookingExceptionsApi - functional programming interface
 * @export
 */
const BookingExceptionsApiFp = function (configuration) {
    const localVarAxiosParamCreator = BookingExceptionsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(bookingTypeId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(bookingTypeId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getByDateRange(bookingTypeId, startDate, endDate, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getByDateRange(bookingTypeId, startDate, endDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.getByDateRange']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getExceptionTypes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getExceptionTypes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.getExceptionTypes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTimeModes(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTimeModes(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.getTimeModes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(BookingExceptionToken, cancelAffected, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(BookingExceptionToken, cancelAffected, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {number} [id]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(BookingExceptionToken, id, cancelAffected, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(BookingExceptionToken, id, cancelAffected, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateExceptionConflicts(BookingExceptionToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateExceptionConflicts(BookingExceptionToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BookingExceptionsApi.validateExceptionConflicts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * BookingExceptionsApi - factory interface
 * @export
 */
const BookingExceptionsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = BookingExceptionsApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(bookingTypeId, options) {
            return localVarFp.getAll(bookingTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [bookingTypeId]
         * @param {String} [startDate]
         * @param {String} [endDate]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByDateRange(bookingTypeId, startDate, endDate, options) {
            return localVarFp.getByDateRange(bookingTypeId, startDate, endDate, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExceptionTypes(options) {
            return localVarFp.getExceptionTypes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTimeModes(options) {
            return localVarFp.getTimeModes(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(BookingExceptionToken, cancelAffected, options) {
            return localVarFp.insert(BookingExceptionToken, cancelAffected, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {number} [id]
         * @param {boolean} [cancelAffected]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(BookingExceptionToken, id, cancelAffected, options) {
            return localVarFp.update(BookingExceptionToken, id, cancelAffected, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth policies: Bookings)
         * @param {BookingExceptionToken} [BookingExceptionToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateExceptionConflicts(BookingExceptionToken, options) {
            return localVarFp.validateExceptionConflicts(BookingExceptionToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * BookingExceptionsApi - object-oriented interface
 * @export
 * @class BookingExceptionsApi
 * @extends {BaseAPI}
 */
class BookingExceptionsApi extends BaseAPI {
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    getAll(bookingTypeId, options) {
        return BookingExceptionsApiFp(this.configuration).getAll(bookingTypeId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [bookingTypeId]
     * @param {String} [startDate]
     * @param {String} [endDate]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    getByDateRange(bookingTypeId, startDate, endDate, options) {
        return BookingExceptionsApiFp(this.configuration).getByDateRange(bookingTypeId, startDate, endDate, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    getById(id, options) {
        return BookingExceptionsApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    getExceptionTypes(options) {
        return BookingExceptionsApiFp(this.configuration).getExceptionTypes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    getTimeModes(options) {
        return BookingExceptionsApiFp(this.configuration).getTimeModes(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingExceptionToken} [BookingExceptionToken]
     * @param {boolean} [cancelAffected]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    insert(BookingExceptionToken, cancelAffected, options) {
        return BookingExceptionsApiFp(this.configuration).insert(BookingExceptionToken, cancelAffected, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    remove(id, options) {
        return BookingExceptionsApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingExceptionToken} [BookingExceptionToken]
     * @param {number} [id]
     * @param {boolean} [cancelAffected]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    update(BookingExceptionToken, id, cancelAffected, options) {
        return BookingExceptionsApiFp(this.configuration).update(BookingExceptionToken, id, cancelAffected, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth policies: Bookings)
     * @param {BookingExceptionToken} [BookingExceptionToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BookingExceptionsApi
     */
    validateExceptionConflicts(BookingExceptionToken, options) {
        return BookingExceptionsApiFp(this.configuration).validateExceptionConflicts(BookingExceptionToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { BookingExceptionsApi, BookingExceptionsApiAxiosParamCreator, BookingExceptionsApiFactory, BookingExceptionsApiFp };
//# sourceMappingURL=booking-exceptions-api.js.map
